import { render } from "./WidgetBmbSeiteMerken.vue?vue&type=template&id=6f1f9e33&scoped=true&ts=true"
import script from "./WidgetBmbSeiteMerken.vue?vue&type=script&lang=ts"
export * from "./WidgetBmbSeiteMerken.vue?vue&type=script&lang=ts"

import "./WidgetBmbSeiteMerken.vue?vue&type=style&index=0&id=6f1f9e33&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1f9e33"]])

export default __exports__